export enum TestType {
  G4_TEST_CASE = 'G4_TEST_CASE',
  G5_TEST_CASE = 'G5_TEST_CASE',
  MANUAL_TEST_CASE = 'MANUAL_TEST_CASE'
}
